import React, { useEffect, useState, useContext } from "react";
import SellerSidebar from "../../../navigation/sellerNavigation";
import { getData } from "../../../fetchRoutes/getData";
import PropertyCard from "../../../utility/propertyCard";
import UpdateDetailPopUp from "./updateDetail";
import SellerMobileSidebar from "../../../navigation/sellerMobileNavigation";
import { DeviceContext } from "../../../context/deviceContext";

export default function UpdateDetailContainer() {

    const myPropertiesUrl = process.env.REACT_APP_MY_PROPERTIES;
    const {isMobile}= useContext(DeviceContext);

    const [properties, setProperties] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState(null);

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const propertiesPerPage = isMobile ? 2:8;


    // Pagination
    const indexOfLastProperty = currentPage * propertiesPerPage;
    const indexOfFirstProperty = indexOfLastProperty - propertiesPerPage;
    const currentProperties = properties.slice(indexOfFirstProperty, indexOfLastProperty);

    const totalPages = Math.ceil(properties.length / propertiesPerPage);

    

    useEffect(() => {
        async function fetchProperties() {
            try {
                const response = await getData(myPropertiesUrl);
                if (response.status === 'Success') {
                    setProperties(response.data);
                }
            } catch {
                setError('Failed to fetch properties');
            } finally {
                setLoading(false);
            }
        }
        fetchProperties();
    }, [myPropertiesUrl]);


    const handleClosePopup = () => {
        setShowPopup(false);
    };

    // Handle auction form popup
    const handleAuctionClick = (property) => {
        setSelectedProperty(property);
        setShowPopup(true);
    };


    return (
        <main className="sellerDashboard">
            {isMobile ? <SellerMobileSidebar/> :<SellerSidebar />}
            <div className={`container ${currentProperties.length <4 && 'moreProperties'}`}>
                <h1 className="containerTitle">UPDATE PROPERTY AND AUCTION DETAILS</h1>
                <div className="propertyList">
                    {isLoading ? (
                        <p className="loadingText">Loading properties...</p>
                    ) : currentProperties.length > 0 ? (
                        currentProperties.map((property) => (
                            <PropertyCard
                                key={property._id}
                                property={property}
                                onButtonClick={handleAuctionClick}
                                buttonLabel="Update Details"
                                isAuctionDisabled={false}
                                secondLabel= {property.auction ? "Close Auction" : "View Details"}
                            />
                            
                        ))
                    ) : (
                        <p className="noPropertiesText">No properties found.</p>
                    )}
                    {error && <p className="errorMessage">{error}</p>}
                </div>

                {/* Pagination Controls */}
                {totalPages > 1 && (
                    <div className="pagination">
                        <button
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                            disabled={currentPage === 1}
                            className={`btnPagination ${currentPage === 1 ? 'disabled' : ''}`}
                        >
                            Previous
                        </button>

                        <span className="pageInfo">Page {currentPage} of {totalPages}</span>

                        <button
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                            disabled={currentPage === totalPages}
                            className={`btnPagination ${currentPage === totalPages ? 'disabled' : ''}`}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>

            {showPopup && (
                <UpdateDetailPopUp
                    property={selectedProperty}
                    onClose={handleClosePopup}
                    
                />
            )}

            
        </main>
    );
}
